import {
  GET_BACKSTAGE,
  INSERT_BACKSTAGE,
  UPDATE_BACKSTAGE,
  DELETE_BACKSTAGE,
  TOGGLE_BACKSTAGE_STATUS,
} from "./backstage.type";

const initialState = {
  backstage: [],
  total: 0,
};

const backstageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BACKSTAGE:
      return {
        ...state,
        backstage: action.payload.backstage,
        total: action.payload.total,
      };

    case INSERT_BACKSTAGE:
      return {
        ...state,
        backstage: [action.payload, ...state.backstage],
        total: state.total + 1,
      };

    case UPDATE_BACKSTAGE:
      return {
        ...state,
        backstage: state.backstage.map((item) =>
          item._id === action.payload.id ? action.payload.data : item
        ),
      };

    case DELETE_BACKSTAGE:
      return {
        ...state,
        backstage: state.backstage.filter((item) => item._id !== action.payload),
        total: state.total - 1,
      };

    case TOGGLE_BACKSTAGE_STATUS:
      return {
        ...state,
        backstage: state.backstage.map((item) =>
          item._id === action.payload.id ? action.payload.data : item
        ),
      };

    default:
      return state;
  }
};

export default backstageReducer;
